import React, { useCallback, useEffect, useState } from 'react';
import {
	useLocation
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Icofont from 'react-icofont';
import { List, Dialog, Popup, Avatar } from 'antd-mobile';
import { Action, errorCatch, GET, JSXMap, useAuth, useNavigation, useTranslateContext, useUserConfigContext, useUserContext, ycStorage } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { useLangSwitchContext } from '../../../common/Context';
import { LogoutOutlined } from '@ant-design/icons';
import MenuLevelOne from '../../components/MenuLevelOne';
import { MaxIcon, ycBucket } from '../../../common/Tool';
import QRCode from 'react-qr-code';
import { Button } from 'antd';

var _ = require('lodash');

export default function Sidebar(props) {
	// const { open, setOpen, menu } = props;
	const { open, menu, menuClose, getStack } = props;
	let navigate = useNavigation();
	const auth = useAuth();
	const dispatch = useDispatch();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	const location = useLocation();
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);
	const role_by_id = useSelector(state => state.home.role_by_id);
	const status = useSelector(state => state.home.status);
	const notify = useSelector(state => state.home.notify);

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT
	const maxbot = process.env.REACT_APP_MAXBOT

	// useEffect(() => {
	// 	setOpen(false)
	// }, [location.pathname]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}
	function getCurrencyValue(value, color) {
		if (!value) {
			return (<span style={{ color: "grey" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (color) {
			return (<span style={{ color: color }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (value >= 0) {
			return (<span style={{ color: "rgb(63, 134, 0)" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
		if (value < 0) {
			return (<span style={{ color: "red" }}>
				{(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
			</span>)
		}
	}

	const [idCard, setIdCard] = useState()
	const loadIdCard = useCallback(() => {
		GET(auth, '/api/idcard', ({ data }) => {
			if (data) {
				setIdCard(data)
			}
		}, (err) => errorCatch(err))
	}, [auth])

	return (
		<Popup
			visible={open}
			// onMaskClick={() => setOpen(false)}
			onMaskClick={menuClose}
			position='right'
			bodyStyle={{ width: '80vw' }}
		>
			<div className='sidebar' style={{ height: "100%", overflowY: "auto" }}>
				<div>
					{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
						<Avatar src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : ""} />
						<div className='user-name'>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
						</div>
						<div>
							<Action
								auth={auth}
								action={() => {
								}}
								object={idCard}
								modal={{
									title: "QR-id"
								}}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={(props) => {
									const { object } = props;
									return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
										{object &&
											<div>
												<div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

													<div className='user-name'>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
													</div>
												</div>

												<div style={{ padding: "15px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
													<QRCode level="M" value={object} />
												</div>

												<div style={{ display: "flex", justifyContent: "center" }}>
													<Button onClick={loadIdCard}>Обновить</Button>
												</div>
											</div>}
									</div>
								}}
								trigger={(click) => (
									<div onClick={event => {
										event.stopPropagation();
										loadIdCard()
										click()
									}}>
										<i className="fa fa-qrcode" style={{ color: "black", fontSize: "42px", margin: "3px 5px 0 0" }}></i>
									</div>
								)}
							/>
						</div>
					</div>}
					<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
						<div>
							<LogoutOutlined />
							<span style={{ paddingLeft: "5px" }}> {t("Выход")}</span>
						</div>
						<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
							<Icofont icon="logout" />
						</div>
					</div>
				</div>
				<div>
					{langSwitch}
				</div>
				<div>
					<div style={{ padding: "5px 0px", display: "flex", alignItems: "center", gap: "5px" }}>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-telegram" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.tgchatid) && <div>Telegram</div>}
										{(user && user.tgchatid) && <div>Telegram</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-vk" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.vk) && <div>VK</div>}
										{(user && user.vk) && <div>VK</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.maxchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><MaxIcon width={14} height={14} color="#4096ff" /></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.maxchatid) && <div>Max</div>}
										{(user && user.maxchatid) && <div>Max</div>}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div>
					{!!akkauntiPolzovatelei && <div className="bg bg-grey" style={{ padding: "5px 10px", textAlign: "left", marginBottom: "5px" }}>
						{JSXMap(akkauntiPolzovatelei, (e, idx) => {
							return (<div key={idx} style={{ display: "flex", justifyContent: "space-between", gap: "5px", padding: (idx != 0) ? "10px 0px 0px 0px" : "" }}>
								<div>
									<div style={{ fontSize: "12px", color: "grey" }}>
										{(e?.akkaunt?.akkauntTypeID == 2) && <span>Основной счет</span>}
										{(e?.akkaunt?.akkauntTypeID == 9) && <span>Накопительный счет</span>}
									</div>
									<div>
										<span>№{e?.akkaunt?.nomerAkkaunta}</span>
									</div>
								</div>
								<div style={{ textAlign: "right" }}>
									{getCurrencyValue(e?.akkaunt?.ostatok)}
								</div>
							</div>)
						})}
					</div>}
					<div style={{ padding: "0px 0px" }}>
						<List>

							<List.Item
								prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
								className={"bg-blue"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
									{t("Главный сайт")}
								</a>
							</List.Item>
							{/* <List.Item
						prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
						className={"bg-orange"}>
						<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
							{t("Личный кабинет")}
						</a>
					</List.Item> */}
							<List.Item
								prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
								className={"bg-green"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
									{t("Войти в мероприятие")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
									{t("Профиль")}
								</a>
							</List.Item>
						</List>
					</div>
					<MenuLevelOne menu={menu(status, notify)} menuClose={menuClose} getStack={getStack} />
				</div>
			</div>
		</Popup>
	);
}